import { RouterName } from '@/constant/data';
import { StorageName } from '@/constant/enum';
import { history } from '@umijs/max';
import { debounce } from 'lodash-es';

export const jumpLoginPage = debounce(() => {
  localStorage.removeItem(StorageName.SessionKey);
  history.replace(RouterName.Login);
});

export const openNewTab = (url: string): void => {
  console.log(url, 'url');
  const a = document.createElement('a');
  a.rel = 'noopener';
  a.href = url;
  a.target = '_blank';
  a.click();
};
